import { gql } from "@apollo/client/core";

export const GET_PRODUCT = gql`
  query Products {
    products(first: 10) {
      edges {
        node {
          id
        }
      }
    }
  }
`;

export const CUSTOMER_ACCESS_TOKEN_CREATE = gql`
  mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`;

export const UPDATE_CUSTOMER_DETAILS = gql`
  mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {
    customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
      }
      customerUserErrors {
        code
      }
    }
  }
`;

const CUSTOMER_PASSWORD_RESET = gql`
  mutation customerReset($id: ID!, $input: CustomerResetInput!) {
    customerReset(id: $id, input: $input) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
      }
    }
  }
`;

export const CUSTOMER_PASSWORD_RECOVER = gql`
  mutation customerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        code
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const CUSTOMER_CREATE = gql`
  mutation customerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customer {
        firstName
        lastName
        email
        phone
        acceptsMarketing
      }
      customerUserErrors {
        field
        message
        code
      }
    }
  }
`;

export const GET_VARIANT_STORE_AVAILABILITY = gql`
  query getProductWithStoreAvailability($id: ID!, $latitude: Float!, $longitude: Float!) {
    product(id: $id) {
      id
      title
      variants(first: 10) {
        edges {
          node {
            id
            title
            storeAvailability(first: 10, near: { latitude: $latitude, longitude: $longitude }) {
              edges {
                node {
                  available
                  pickUpTime
                  quantityAvailable
                  location {
                    id
                    name
                    address {
                      address1
                      city
                      country
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_BY_ID = gql`
  query GetProduct($id: ID!) {
    product(id: $id) {
      id
      title
      handle
      description
      tags
      variants(first: 100) {
        edges {
          node {
            id
            title
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            availableForSale
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_BY_HANDLE = gql`
  query GetProduct($handle: String!) {
    product(handle: $handle) {
      id
      title
      handle
      description
      tags
      collections(first: 250) {
        edges {
          node {
            id
          }
        }
      }
      variants(first: 100) {
        edges {
          node {
            id
            title
            sku
            price {
              amount
              currencyCode
            }

            selectedOptions {
              name
              value
            }
            compareAtPrice {
              amount
              currencyCode
            }
            availableForSale
            membersPricing: metafield(namespace: "pricing", key: "members") {
              key
              value
            }
          }
        }
      }
    }
  }
`;
